module.exports = __webpack_public_path__ + "img/back_3.564b89e2.jpg";